import React, { useEffect, useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CardTable2";
import axios from "axios";
import { apiKey } from "../../../../config/config";
import MessageCard from "../../../../components/AdminCards/MessageCard";
import dayjs from "dayjs";
import { languageHelper } from "../../../../config/helperFunctions";



function MultipleVatReport() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const columns = [
    {
      header: languageHelper("SN") || "SN",
      cell: (row) => row.row.index + 1,
    },
    {
      header: languageHelper("Start Date & Time") || "Start Date & Time",
      accessorKey: "startDateTime",
      cell: row => dayjs(row.getValue()).format("DD/MM/YYYY hh:mm: A")
    },
    {
      header: languageHelper("End Date & Time") || "End Date & Time",
      accessorKey: "endDateTime",
      cell: row => dayjs(row.getValue()).format("DD/MM/YYYY hh:mm: A")
    },
    {
      header: languageHelper("Vat Name") || "Vat Name",
      accessorKey: "vat_name",
    },
    {
      header: languageHelper("Vat") || "Vat",
      accessorKey: "total_vat",
    },
    {
      header: languageHelper("Total Sale") || "Total Sale",
      accessorKey: "total_sale",
    },
  ];
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [vats, setVats] = useState([]);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [selectedOutlet, setSelectedOutlet] = useState();
  const [selectedVat, setSelectedVat] = useState();

  const handleOutletSelect = (e) => {
    setSelectedOutlet(e.value);
  };

  const handleVatSelect = (e) => {
    setSelectedVat(e.value);
  };

  const selectButton = [
    {
      placeholder: languageHelper("Vat") || "Vat",
      options: vats,
      onChange: handleVatSelect,
    },
  ];

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/vats`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      })
      .then((res) => {
        const mappedVats = res.data.map((vat) => ({
          value: vat.id,
          label: vat.name,
        }));
        setVats(mappedVats);
        setError(false);
      })
      .catch((err) => {
        setError(err.response.data.message || "Error occured");
      });
  }, [user?.token, user?.user.outlet_id]);

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/multi-vat-report`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: selectedOutlet || user?.user.outlet_id,
          from: startDate,
          to: endDate,
          vatId: selectedVat,
        },
      })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
      })
      .finally(() => {});
  }, [endDate, selectedOutlet, selectedVat, startDate, user?.user.outlet_id, user?.token]);

  if (error) {
    return <MessageCard error={error} />;
  }

  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={languageHelper("Multiple Vat Report") || "Multiple Vat Report"}
        selectButton={selectButton}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        downloads={true}
        dateTime={true}
        handleOutletSelect={handleOutletSelect}
      />
    </main>
  );
}

export default MultipleVatReport;
